// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/card/card.less
// module id = 2700
// module chunks = 0 1